import { InquiryPeriod } from "../../store/inquiries/types";
import usePeriods from "../common/usePeriods";

export default function useMaidontuotantoPeriods(): InquiryPeriod[] {
  return usePeriods("maidontuotanto");
}
